import { render } from "./ExtendView.vue?vue&type=template&id=f818e4ea&scoped=true"
const script = {}

import "./ExtendView.vue?vue&type=style&index=0&id=f818e4ea&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f818e4ea"]])

export default __exports__